document.addEventListener("DOMContentLoaded", () => {
  try {
	const isJustChangeLang = sessionStorage.getItem("justChangedLang") === "true";
	const SUPPORTED_LANGUAGES = ["sv"]; // add more as needed
	const DEFAULT_LANGUAGE = "en";

	// Stop redirect loop when language was manually changed
	if (isJustChangeLang) {
  	  sessionStorage.removeItem("justChangedLang");
  	  console.info("Language was changed manually — skipping redirect.");
  	  return null;
	}

    let storedLang = localStorage.getItem("preferredLang");
    const browserLang = (navigator.language || navigator.userLanguage || "").toLowerCase();
    const path = window.location.pathname + window.location.search + window.location.hash;
	const isInvalidStoredLang = storedLang && !SUPPORTED_LANGUAGES.includes(storedLang);

    if (isInvalidStoredLang) {
      localStorage.removeItem("preferredLang");
      storedLang = null;
    }

    const matchedLang = SUPPORTED_LANGUAGES.find(lang => browserLang.startsWith(lang));
    const targetLang = storedLang || matchedLang;

	if (!targetLang || targetLang === DEFAULT_LANGUAGE) return null;
	if (path.startsWith(`/${targetLang}`)) return null;

    const newUrl = `${window.location.origin}/${targetLang}${path}`;
    window.location.replace(newUrl);
  } catch (err) {
    console.warn("Redirect skipped:", err);
  }
});